import { FC } from 'react';
import { Avatar, Stack, SxProps, Theme, Typography } from '@mui/material';
import { useFileLink } from 'src/hooks/use-file-link';
import { SHARED_BUCKET_NAME } from 'src/config-global';

type Props = {
  name: string;
  image?: string;
  size?: number;
  phone?: string;
  isDraft?: boolean;
  isAvatarOnly?: boolean;
  sx?: SxProps<Theme>;
  hideName?: boolean;
  isSharedBucket?: boolean;
};

export const UserAvatar: FC<Props> = ({
  image,
  name,
  size = 40,
  phone,
  isDraft,
  isAvatarOnly,
  sx,
  hideName = false,
  isSharedBucket = false,
}) => {
  const getFileLink = useFileLink();

  const hasName = name.trim().length > 0;

  return (
    <Stack direction="row" alignItems="center" spacing={2} sx={sx}>
      <Avatar
        alt={name}
        src={getFileLink(image, isSharedBucket ? SHARED_BUCKET_NAME : undefined)}
        sx={{ width: size, height: size, fontSize: `${size / 2}px` }}
        variant="circular"
        color={isDraft ? 'default' : 'primary'}
      />
      {!isAvatarOnly && (
        <Stack direction="column">
          {!hideName && <Typography variant="body1">{name}</Typography>}
          <Typography variant="body1" color={hasName ? 'text.disabled' : 'text.primary'}>
            {phone}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
